<script>

    import { onMount } from "svelte";
    import { getContext } from "svelte";

    import {
        checkLocalSession
    } from "../../utils/session";


    const router = getContext('router');


    onMount(() => {

        checkLocalSession(router);

    });

</script>

